/*==================================================
PETRA STELLAM
RUNWAY ARCHIVE
FINAL JAVASCRIPT
==================================================*/


document.addEventListener("DOMContentLoaded", () => {



/*==================================================
PETRA STELLAM
GLOBAL LUXURY CIRCLE CURSOR
==================================================*/


const cursor = document.createElement("div");

cursor.className = "ps-fashion-cursor";

cursor.innerHTML = "VIEW";

document.body.appendChild(cursor);



document.addEventListener("mousemove", (e)=>{


    cursor.style.left = e.clientX + "px";

    cursor.style.top = e.clientY + "px";


    cursor.classList.add("active");


});



document.addEventListener("mouseleave",()=>{

    cursor.classList.remove("active");

});





/*==================================================
COLLECTION CARD TILT
==================================================*/


const cards = document.querySelectorAll(
    ".ps-collection-card"
);



cards.forEach(card => {



    card.addEventListener("mousemove", (e) => {


        if(window.innerWidth < 769) return;



        const rect = card.getBoundingClientRect();



        const x =
        (e.clientX - rect.left)
        /
        rect.width
        -
        .5;



        const y =
        (e.clientY - rect.top)
        /
        rect.height
        -
        .5;



        card.style.transform = `

        perspective(1000px)

        rotateX(${y * -6}deg)

        rotateY(${x * 6}deg)

        translateZ(20px)

        `;


    });



    card.addEventListener("mouseleave", () => {


        card.style.transform = "";

    });





    /* Mobile tap expansion */


    card.addEventListener("click", () => {


        if(window.innerWidth <= 768){


            cards.forEach(item => {

                if(item !== card){

                    item.classList.remove("active");

                }

            });


            card.classList.toggle("active");


        }


    });



});





/*==================================================
SPOTLIGHT EFFECT
==================================================*/


const wrapper = document.querySelector(
    ".ps-collection-wrapper"
);



if(wrapper){


document.addEventListener("mousemove", (e)=>{


    const rect =
    wrapper.getBoundingClientRect();



    const x =
    ((e.clientX - rect.left)
    /
    rect.width)
    *
    100;



    const y =
    ((e.clientY - rect.top)
    /
    rect.height)
    *
    100;



    wrapper.style.setProperty(
        "--mouse-x",
        x + "%"
    );


    wrapper.style.setProperty(
        "--mouse-y",
        y + "%"
    );



});



wrapper.addEventListener("mouseenter", ()=>{


    wrapper.classList.add("active");


});



wrapper.addEventListener("mouseleave", ()=>{


    wrapper.classList.remove("active");


});


}





/*==================================================
SCROLL REVEAL
==================================================*/


const revealItems =
document.querySelectorAll(
    ".ps-collection-card"
);



if("IntersectionObserver" in window){


const observer =
new IntersectionObserver(
(entries)=>{


entries.forEach(entry=>{


    if(entry.isIntersecting){


        entry.target.classList.add(
            "visible"
        );


        observer.unobserve(
            entry.target
        );


    }


});


},
{
    threshold:.25
}
);



revealItems.forEach(item=>{


    observer.observe(item);


});


}else{


revealItems.forEach(item=>{


    item.classList.add("visible");


});


}





});